// import API from "../../../app/api";

// export const getProductDetails = async () => {
//   try {
//     const response = await API.get("/products/aquarius-214");
//     if (response.data.success) {
//       return response.data.data;
//     }
//     return [];
//   } catch (error) {
//     console.log(error);
//     return [];
//   }
// };

import API from "../../../app/api";

export const getProductDetails = async (slug) => {
  try {
    const response = await API.get(`/products/${slug}`);

    return response.data?.data || [];
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch product details"
    );
  }
};